/// Ratio of map view port to increase at edge to preload blocks around the
/// view port
export const MAP_VIEW_GUTTER_RATIO = 0.5

export const CRAWLER_USER_AGENTS = /bot|googlebot|crawler|spider|robot|crawling|baidu|bing|msn|duckduckgo|teoma|slurp|yandex|prerender|facebookexternalhit|facebot/i



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/constants.ts